import React from 'react';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import WriterPaperMapPanel from '@/components/writer/WriterPaperMapPanel';
import WriterBibliographyPanel from '@/components/writer/WriterBibliographyPanel';
import type { PaperMap, ValidationDiagnostic } from '@/lib/writer/structured';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  projectId: string;
  paperMap: PaperMap | null;
  diagnostics: ValidationDiagnostic[];
  paperMapLoading: boolean;
  refreshTick: number;
  /** Header-level actions (memory, submit as version) rendered inside the sheet. */
  actions?: React.ReactNode;
}

/**
 * Single "Draft" sheet for the compact Writer layout: structure outline,
 * bibliography and the header actions that don't fit a phone toolbar.
 */
const WriterDraftSheet: React.FC<Props> = ({
  open,
  onOpenChange,
  projectId,
  paperMap,
  diagnostics,
  paperMapLoading,
  refreshTick,
  actions,
}) => (
  <Sheet open={open} onOpenChange={onOpenChange}>
    <SheetContent side="right" className="w-full sm:max-w-md p-0 flex flex-col gap-0">
      <SheetHeader className="px-4 py-3 border-b border-border/60 text-left">
        <SheetTitle className="text-sm">Draft</SheetTitle>
      </SheetHeader>
      <div className="flex-1 min-h-0 overflow-y-auto">
        {actions ? (
          <div className="flex flex-wrap items-center gap-2 px-4 py-3 border-b border-border/60">
            {actions}
          </div>
        ) : null}
        <WriterPaperMapPanel
          paperMap={paperMap}
          diagnostics={diagnostics}
          loading={paperMapLoading}
        />
        <WriterBibliographyPanel
          projectId={projectId}
          refreshTick={refreshTick}
          citedKeys={paperMap?.sections.flatMap((section) => section.citekeys_used) ?? []}
        />
      </div>
    </SheetContent>
  </Sheet>
);

export default WriterDraftSheet;
